import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
export default new Router({
  hashbang: false,
  mode: "history",
  routes: [
    // {
    //   path: "*",
    //   meta: { title: "404" },
    //   component: () => import("@/views/others/404.vue"),
    // },
    {
      path: "/",
      component: () => import("@/views/_layout.vue"),
      meta: { isPublic: true },
      redirect: { name: "landingPage" },
      children: [
        {
          path: "/register",
          name: "registerUser",
          meta: {
            title: "Únete a Havoline Moto Club, registra tus datos y disfruta de beneficios.",
            description: "Sé parte de Havoline Moto Club, una vez registrado podrás acumular puntos con los códigos de productos Havoline 4T y canjear por increíbles premios.",
            canonical: "register"
          },
          component: () => import("@/views/login/addUser2.vue"),
        },
        // Ruta para completar registro con google (solo para moteros)
        {
          path: "/registerGoogle",
          name: "registerGoogle",
          meta: { title: "Completar registro por google" },
          component: () => import("@/views/user/addUserGoogle.vue"),
        },
        {
          path: "/register?",
          name: "registerUser2",
          meta: {
            title:
              "Únete al Motoclub de Havoline, registra tus datos y disfruta los beneficos.",
            description:
              "Sé parte del moto Club e Havoline, tienes grandes beneficios, una vez registrado puede acumular puntos con los productos Havoline 4T y canjear por premios.",
          },
          component: () => import("@/views/login/addUser2.vue"),
        },
        {
          path: "/register/rediferido/:code",
          name: "registerUser",
          meta: { title: "Registro de usuarios" },
          component: () => import("@/views/login/addUser2.vue"),
        },
        // Rutas para registro rapido
        {
          path: "/quick/registration",
          name: "landingQuickRegister",
          meta: { title: "Registro de usuarios" },
          component: () => import("@/views/login/landingRegister.vue"),
        },
        {
          path: "/landing/register",
          name: "landingRegister",
          meta: { title: "Registro de usuarios" },
          component: () => import("@/views/login/landingRegister.vue"),
        },
        // Ruta para la actualización de información del usuario
        {
          path: "/updateData",
          name: "updateData",
          meta: { title: "Actualización de información" },
          component: () => import("@/views/login/home.vue"),
        },
        {
          path: "/:link([a-zA-Z]+-[a-zA-Z]+-\\d+)",
          name: "updateDataLink",
          meta: { title: "Actualización de información" },
          component: () => import("@/views/login/home.vue"),
        },
        {
          path: "/gracias",
          name: "thankyou",
          meta: { title: "¡Gracias!" },
          component: () => import("@/views/login/thankYouPage.vue"),
        },
        {
          path: "/tecubre/:company",
          name: "registerUserByCompany",
          meta: { title: "Registro de usuarios" },
          component: () => import("@/views/login/addUserByCompany.vue"),
        },
        {
          path: "/404",
          name: "404",
          meta: { title: "Página no encontrada" },
          component: () => import("@/views/others/404.vue"),
        },
        // {
        //   path: "/login/:option",
        //   name: "login2",
        //   meta: {
        //     title:
        //       "Ingresa al moto club y acumula puntos para redimir con premios",
        //     description:
        //       "Ingresa con tu clave y contraseña al moto club de havoline, completa tus datos e ingresa los códigos de los productos Havoline 4T para acumular tus puntos.",
        //   },
        //   component: () => import("@/views/login/login.vue"),
        // },
        {
          path: "/campaing/:option",
          name: "campaing",
          meta: {
            title:
              "Campaña",
            description:
              "Campaña",
          },
          component: () => import("@/views/login/campaing.vue"),
        },
        {
          path: "/campaing",
          name: "campaing",
          meta: {
            title:
                "Campaña",
            description:
                "Campaña",
          },
          component: () => import("@/views/login/campaing.vue"),
        },
        {
          path: "/alliances/:name",
          name: "alliances",
          meta: {
            title: "Alianzas"
          },
          component: () => import("@/views/login/alliances.vue"),
        },
        {
          path: "/allianceDetail/:id",
          name: "allianceDetail",
          props: true,
          meta: {
            title: "Detalle Alianza"
          },
          component: () => import("@/views/login/alliancesDetail.vue"),
        },
        {
          path: "/login",
          name: "login",
          meta: {
            title: "Ingresa a Havoline Moto Club y acumula puntos para redimir por premios",
            description: "Ingresa con tu clave y contraseña a Havoline MotoClub, completa tus datos e ingresa los códigos de productos Havoline 4T para acumular puntos.",
            canonical: "login"
          },
          component: () => import("@/views/login/login.vue"),
        },
        {
          path: "/login/lubricador",
          name: "loginLubricator",
          meta: {
            title:
              "Ingresa al moto club y acumula puntos para redimir con premios",
            description:
              "Ingresa con tu clave y contraseña al moto club de havoline, completa tus datos e ingresa los códigos de los productos Havoline 4T para acumular tus puntos.",
          },
          component: () => import("@/views/login/loginLubricator.vue"),
        },
        {
          path: "/login-distribuidor",
          name: "loginDistributor",
          meta: {
            title:
              "Ingresa al moto club y acumula puntos para redimir con premios",
            description:
              "Ingresa con tu clave y contraseña al moto club de havoline, completa tus datos e ingresa los códigos de los productos Havoline 4T para acumular tus puntos.",
          },
          component: () => import("@/views/login/loginDistributor.vue"),
        },
        {
          path: "/login-punto-de-venta",
          name: "loginPointOfsale",
          meta: {
            title:
              "Ingresa al moto club y redime premios",
            description:
              "Ingresa con tu clave y contraseña al moto club de havoline, y redime los productos del catálogo.",
          },
          component: () => import("@/views/login/loginPointOfSale.vue"),
        },
        {
          path: "/inicio",
          name: "landingPage",
          meta: {
            title: "Havoline Moto Club te brinda grandes beneficios que te cubren.",
            description: "Havoline Moto Club, es un programa que te permite acumular puntos por tus compras de productos Havoline 4T y redimirlos por accesorios, herramientas y otros beneficios para ti y tu moto.",
            canonical: "inicio"
          },
          component: () => import(/* webpackChunkName: "Inicio" */ "@/views/login/home.vue"),
        },
        // {
        //   path: "/promo",
        //   name: "promo",
        //   meta: { title: "Participa" },
        //   component: () => import("@/views/login/promo.vue"),
        // },
        {
          path: "/contactanos",
          name: "contact",
          meta: { 
            title: "Contáctanos",
            canonical: "contactanos"
          },
          component: () => import("@/views/login/contact.vue"),
        },
        {
          path: "/club",
          name: "club",
          meta: { 
            title: "¿Qué es el club?",
            canonical: "club"
          },
          component: () => import("@/views/login/club.vue"),
        },
        {
          path: "/como/registrar/codigos",
          name: "registerCodes",
          meta: { 
            title: "¿Cómo registrar códigos?",
            canonical: "como/registrar/codigos"
          },
          component: () => import("@/views/login/registerCodes.vue"),
        },
        {
          path: "/home",
          name: "home",
          meta: { title: "Perfil" },
          component: () => import("@/views/login/home.vue"),
        },
        {
          path: "/catalogo",
          name: "catalogue",
          meta: {
            title: "Catálogo de accesorios Havoline MotoClub.",
            description: "Conoce todos los productos para moteros que tiene Havoline MotoClub. Cascos, Impermeables, Balaclavas, Correas, Soportes de casco, Soporte Celular, Cascos, Bonos de combustible y más",
            canonical: "catalogo"
          },
          component: () => import("@/views/user/catalogue/catalogue.vue"),
        },
        {
          path: "/catalogo/lub",
          name: "catalogueLub",
          meta: {
            title: "Catálogo de accesorios Havoline MotoClub.",
            description: "Conoce todos los productos para lubricadores que tiene Havoline MotoClub. Cascos, Impermeables, Balaclavas, Correas, Soportes de casco, Soporte Celular, Cascos, Bonos de combustible y más",
            canonical: "catalogo/lub"
          },
          component: () => import("@/views/user/catalogue/catalogueLub.vue"),
        },
        {
          path: "/productos",
          name: "sectionWebProduct",
          meta: { title: "Sección de productos" },
          component: () => import("@/views/login/sectionWebProduct.vue"),
        },
        {
          path: "/catalogo/combustible",
          name: "catalogueCom",
          meta: {
            title: "Catálogo de productos Moto club Havoline",
            description: "Conoce todo los productos para moteros que tiene el motoclub havoline. cascos, impermeables, balaclavas, correas, soportes de casco, soporte Celular y más"
          },
          component: () => import("@/views/user/catalogue/bonoTexaco.vue"),
        },
        {
          path: "/catalogo/detalles/:id",
          name: "catalogueDetailsM",
          meta: {
            title: "Catálogo de productos Moto club Havoline",
            description: "Conoce todo los productos para moteros que tiene el motoclub havoline. cascos, impermeables, balaclavas, correas, soportes de casco, soporte Celular y más"
          },
          component: () => import("@/views/user/catalogue/details.vue"),
        },
        {
          path: "/reset/password/:token",
          name: "resetPassword",
          meta: { title: "Recuperar contraseña" },
          component: () => import("@/views/login/resetPassword.vue"),
        },
        // {
        //   path: "ecommerce/catalogo",
        //   name: "catalogueEcommerce1",
        //   meta: {
        //     title: "Catálogo de productos Moto club Havoline",
        //     description: "Conoce todo los productos para moteros que tiene el motoclub havoline. cascos, impermeables, balaclavas, correas, soportes de casco, soporte Celular y más"
        //   },
        //   component: () =>
        //     import("@/views/user/catalogueEcommerce/catalogueEcommerce.vue"),
        // },
        {
          path: "/preguntas/frecuentes",
          name: "frequentQuestions",
          meta: {
            title: "Preguntas frecuentes Havoline Moto Club.",
            description: "Responde todas tus preguntas ¿Cuáles son los beneficios del Moto Club? ¿Cómo redimir premios del Moto Club? ¿Cómo sumar puntos en el Moto Club? ¿Cuáles son los premios del MotoClub?",
            canonical: "preguntas/frecuentes"
          },
          component: () => import("@/views/login/frecuentQuestions.vue"),
        },
        // {
        //   path: "/adminQuestion",
        //   name: "adminQuestion",
        //   meta: { title: "Administrador Preguntas" },
        //   component: () => import("@/views/user/admin/adminQuestion.vue")
        // },
        // {
        //   path: "/adminDocuments",
        //   name: "adminDocuments",
        //   meta: { title: "Administrador Preguntas" },
        //   component: () => import("@/views/user/admin/adminDocuments.vue")
        // },
        // {
        //   path: "/adminBanner",
        //   name: "adminBanner",
        //   meta: { title: "Administrador Banner" },
        //   component: () => import("@/views/user/admin/adminBanner.vue")
        // }
        {
          path: "havoblog-list",
          name: "listAllHavoblogs",
          meta: { 
            title: "Blog | Havoline Motoclub",
            description: "Obtén información valiosa para mantener tu moto en perfectas condiciones y maximiza tus recompensas en nuestro programa de fidelización. ¡Sigue leyendo y únete a nuestra comunidad de entusiastas de las motos y mecánicos expertos."
          },
          component: () => import("@/views/user/havoblog/listAllHavoblogs.vue"),
        },
        {
          path: "havoblog/description-blog-:nameSlug",
          name: "descriptionHavoblog",
          meta: { title: "Descripción Blog | Havoline Motoclub" },
          component: () => import("@/views/user/havoblog/descriptionHavoblog.vue"),
        },
        {
          path: "consulta/alianza/usuario/:id",
          name: "userDataAlliance",
          meta: { title: "Información del propietario del carnet" },
          component: () => import("@/views/user/userDataAlliance.vue"),
        },
      ],
    },
    {
      path: "/app",
      name: "app",
      component: () => import("@/views/user/_layout.vue"),
      children: [
        // -------------------- Inicio de las rutas para el CRM Havoline --------------------
        {
          path: "admin/crm-havoline",
          name: "adminCrm",
          meta: { title: "CRM Havoline" },
          component: () => import("@/views/user/admin/crm/adminCrm.vue"),
        },
        // -------------------- Fin de las rutas para el CRM Havoline --------------------


        // -------------------- Inicio lista de rutas para el reporte de stock --------------------
        {
          path: "moto/stock/stock",
          name: "listStock",
          meta: { title: "Stock" },
          component: () => import("@/views/user/stockReport/listStock.vue"),
        },
        {
          path: "moto/stock/redemptions",
          name: "listProductRedemptions",
          meta: { title: "Product Redemptions" },
          component: () => import("@/views/user/stockReport/listProductRedemptions.vue"),
        },
        // -------------------- Fin lista de rutas para el reporte de stock --------------------
        
        // -------------------- Inicio lista de rutas para administrar havoblog --------------------
        {
          path: "admin/havoblog",
          name: "listHavoblog",
          meta: { title: "Listado Havoblogs" },
          component: () => import("@/views/user/havoblog/admin/listHavoblog.vue"),
        },
        {
          path: "admin/havoblog/create",
          name: "createHavoblog",
          meta: { title: "Crear Havoblog" },
          component: () => import("@/views/user/havoblog/admin/createHavoblog.vue"),
        },
        {
          path: "admin/havoblog/edit",
          name: "editHavoblog",
          meta: { title: "Editar Havoblog" },
          component: () => import("@/views/user/havoblog/admin/editHavoblog.vue"),
        },
        {
          path: "admin/havoblog/comments",
          name: "commentsHavoblog",
          meta: { title: "Comentarios de blog" },
          component: () => import("@/views/user/havoblog/admin/listHavoblogComments.vue"),
        },
        // -------------------- Fin lista de rutas para administrar havoblog --------------------
        
        // -------------------- Inicio lista de rutas para la sección de productos --------------------
        {
          path: "admin/list/products",
          name: "listProducts",
          meta: { title: "Listado de productos y distribuidores" },
          component: () => import("@/views/user/admin/productSection/listProductsWeb.vue"),
        },
        {
          path: "admin/create/products",
          name: "createProducts",
          meta: { title: "Crear" },
          component: () => import("@/views/user/admin/productSection/createProducts.vue"),
        },
        {
          path: "admin/edit/products",
          name: "editSectionWeb",
          meta: { title: "Editar" },
          component: () => import("@/views/user/admin/productSection/editProducts.vue"),
        },
        // -------------------- Fin lista de rutas para la sección de productos --------------------
        

        // -------------------- Inicio lista de rutas para la sección de Puntos de venta --------------------
        {
          path: "/admin/listado-puntos-de-venta",
          name: "listPOS",
          meta: { title: "Administrador Puntos de venta" },
          component: () => import("@/views/user/admin/users/listPointsOfSale.vue"),
        },
        // -------------------- Fin lista de rutas para la sección de Puntos de venta --------------------


        {
          path: "moto/mercado/productos",
          name: "productoMotoMercado",
          meta: { title: "Moto Mercado" },
          component: () => import("@/views/user/motoMercado/listProducto.vue"),
        },
        {
          path: "/admin/question",
          name: "adminQuestion1",
          meta: { title: "Administrador Preguntas" },
          component: () => import("@/views/user/admin/adminQuestion.vue"),
        },
        {
          path: "/admin/products",
          name: "adminProducts",
          meta: { title: "Administrador Productos" },
          component: () => import("@/views/user/admin/adminProducts.vue"),
        },
        {
          path: "/admin/products/add",
          name: "addAdminProducts",
          meta: { title: "Administrador Productos" },
          component: () => import("@/views/user/admin/products/add.vue"),
        },
        {
          path: "/admin/products/edit/:id",
          name: "editAdminProducts",
          meta: { title: "Administrador Productos" },
          component: () => import("@/views/user/admin/products/edit.vue"),
        },
        {
          path: "/admin/products/discounts",
          name: "applyDiscounts",
          meta: { title: "Aplicar descuentos" },
          component: () => import("@/views/user/admin/products/applyDiscounts.vue"),
        },
        {
          path: "/admin/history",
          name: "adminHistory",
          meta: { title: "Historial de compras" },
          component: () => import("@/views/user/admin/adminHistory.vue"),
        },
        {
          path: "admin/createLinks",
          name: "updateDataOrRegister",
          meta: { title: "Crear links" },
          component: () => import("@/views/user/admin/createLinks.vue"),
        },
        {
          path: "admin/historyLinks",
          name: "historyLinks",
          meta: { title: "Editar links" },
          component: () => import("@/views/user/admin/historyLinks.vue"),
        },
        // {
        //   path: "/admin/productschevron",
        //   name: "adminProductsChevron",
        //   meta: { title: "Administrador Productos Chevron" },
        //   component: () => import("@/views/user/admin/adminProductsChevron.vue"),
        // },
        // {
        //   path: "/admin/productschevron/add",
        //   name: "addAdminProductsChevron",
        //   meta: { title: "Administrador Productos Chevron" },
        //   component: () => import("@/views/user/admin/productsChevron/addProductChevron.vue"),
        // },
        // {
        //   path: "/admin/productschevron/edit/:id",
        //   name: "editAdminProductsChevron",
        //   meta: { title: "Administrador Productos Chevron" },
        //   component: () => import("@/views/user/admin/productsChevron/editProductChevron.vue"),
        // },
        {
          path: "/admin/documents",
          name: "adminDocuments1",
          meta: { title: "Administrador Preguntas" },
          component: () => import("@/views/user/admin/adminDocuments.vue"),
        },
        {
          path: "/admin/lubricators",
          name: "adminL",
          meta: { title: "Administrador Lubricadores" },
          component: () => import("@/views/user/admin/users/lubricators.vue"),
        },
        {
          path: "/admin/listUser",
          name: "listUser",
          meta: { title: "Administrador Usuarios" },
          component: () => import("@/views/user/admin/users/listUser.vue"),
        },
        {
          path: "/admin/registeredCodes",
          name: "registeredCodesByDay",
          meta: { title: "Registro de códigos por día" },
          component: () => import("@/views/user/admin/users/registeredCodesByDay.vue"),
        },
        {
          path: "/admin/historyPoints",
          name: "historyPoints",
          meta: { title: "Historial de puntos obtenidos" },
          component: () => import("@/views/user/admin/users/historyPoints.vue"),
        },
        {
          path: "/admin/lubricators/reports",
          name: "adminReports",
          meta: { title: "Reportes" },
          component: () => import("@/views/user/admin/users/reports.vue"),
        },
        {
          path: "/admin/banner",
          name: "adminBanner1",
          meta: { title: "Administrador Banner" },
          component: () => import("@/views/user/admin/adminBanner.vue"),
        },
        {
          path: "/admin/bannerAlianzas",
          name: "adminAlianzas",
          meta: { title: "Administrador Alianzas" },
          component: () => import("@/views/user/admin/adminAlianzas.vue"),
        },
        {
          path: "/admin/bonos",
          name: "listPromo",
          meta: { title: "Administrador Bonos" },
          component: () => import("@/views/user/admin/promotional/list.vue"),
        },
        {
          path: "/admin/promo",
          name: "promotions",
          meta: { title: "Crear promoción" },
          component: () => import("@/views/user/admin/promotional/promotions.vue"),
        },
        {
          path: "/admin/promo/:id",
          name: "listPromoUsers",
          meta: { title: "Beneficiarios promoción" },
          component: () => import("@/views/user/admin/promotional/beneficiaryUsers.vue"),
        },
        {
          path: "/admin/regalos",
          name: "listGifting",
          meta: { title: "Administrador Regalos" },
          component: () => import("@/views/user/admin/gifting/list.vue"),
        },
        {
          path: "/sorteo",
          name: "adminLottery",
          meta: { title: "Administrador Sorteo" },
          component: () => import("@/views/user/admin/adminLottery.vue"),
        },
        {
          path: "/user/profile",
          name: "profileUser",
          meta: { title: "Perfil" },
          component: () => import("@/views/user/profile.vue"),
        },
        {
          path: "/user/updateDataUser",
          name: "updateDataUser",
          meta: { title: "Actualización de información" },
          component: () => import("@/views/user/updateDataUser.vue"),
        },
        {
          path: "/lubricador/perfil",
          name: "lubricatorProfile",
          meta: { title: "Perfil" },
          component: () => import("@/views/user/profileLubricator.vue"),
        },
        {
          path: "/punto-de-venta/profile",
          name: "pointOfsaleProfile",
          meta: { title: "Perfil Punto de venta" },
          component: () => import("@/views/user/pointOfsaleProfile.vue"),
        },
        {
          path: "/comercial/perfil",
          name: "comercialProfile",
          meta: { title: "Perfil comercial" },
          component: () =>
            import("@/views/user/comercial/profileComercial.vue"),
        },
        {
          path: "/puntos-de-venta",
          name: "pointsOfSale",
          meta: { title: "Puntos de venta" },
          component: () => import("@/views/user/comercial/pointsOfSale.vue"),
        },
        {
          path: "/dashboard-distribuidor/moteros",
          name: "dashBiker",
          meta: { title: "Dashboard Distribuidor - Moteros" },
          component: () => import("@/views/user/comercial/dashDistributorsBiker.vue"),
        },
        {
          path: "/dashboard-distribuidor/lubricadores",
          name: "dashLub",
          meta: { title: "Dashboard Distribuidor - Lubricadores" },
          component: () => import("@/views/user/comercial/dashDistributorsLub.vue"),
        },
        {
          path: "/dashboard-distribuidor/campaigns",
          name: "distCampaign",
          meta: { title: "Dashboard Distribuidor - Campañas" },
          component: () => import("@/views/user/comercial/distributorCampaigns.vue"),
        },
        {
          path: "/comercial/detalles/lubricador/:id",
          name: "detailsCommercial",
          meta: { title: "Perfil" },
          component: () => import("@/views/user/comercial/details.vue"),
        },
        {
          path: "/user/home",
          name: "homeUser",
          meta: { title: "Inicio" },
          component: () => import("@/views/user/redeemCode.vue"),
        },
        {
          path: "user/inicio/:section",
          name: "landingPage1",
          meta: { title: "Inicio" },
          component: () => import("@/views/login/home.vue"),
        },
        {
          path: "user/catalogo",
          name: "catalogue1",
          meta: { title: "Catalogo" },
          component: () => import("@/views/user/catalogue/catalogue.vue"),
        },
        {
          path: "user/catalogo/lub",
          name: "catalogueLub1",
          meta: { title: "Catálogo Lubricador" },
          component: () => import("@/views/user/catalogue/catalogueLub.vue"),
        },
        {
          path: "punto-de-venta/catalogo",
          name: "cataloguePOS",
          meta: { title: "Catálogo Punto de venta" },
          component: () => import("@/views/user/catalogue/cataloguePOS.vue"),
        },
        // {
        //   path: "user/ecommerce/catalogo",
        //   name: "catalogueEcommerce",
        //   meta: { title: "Catalogo" },
        //   component: () =>

        //     import("@/views/user/catalogueEcommerce/catalogueEcommerce.vue"),
        // },
        {
          path: "user/catalogo/combustible",
          name: "catalogueCom1",
          meta: { title: "Catalogo" },
          component: () => import("@/views/user/catalogue/bonoTexaco.vue"),
        },
        {
          path: "user/catalogo/detalles/:id",
          name: "catalogueDetailsM2",
          meta: { title: "Catalogo" },
          component: () => import("@/views/user/catalogue/details.vue"),
        },
        {
          path: "user/cart",
          name: "userCard",
          meta: { title: "Carrito de compras" },
          component: () => import("@/views/user/catalogueEcommerce/card.vue"),
        },
        {
          path: "user/participa",
          name: "promo1",
          meta: { title: "Participa" },
          component: () => import("@/views/login/promo.vue"),
        },
        {
          path: "user/cart/data",
          name: "formAddress",
          meta: { title: "Participa" },
          component: () =>
            import("@/views/user/catalogueEcommerce/formAddress.vue"),
        },
        {
          path: "user/preguntas/frecuentes",
          name: "frequentQuestionsP",
          meta: { title: "Preguntas Frecuentes Havoline MotoClub" },
          component: () => import("@/views/login/frecuentQuestions.vue")
        },
        {
          path: "user/como/registrar/codigos",
          name: "registerCodesP",
          meta: { title: "¿Cómo registrar códigos?" },
          component: () => import("@/views/login/registerCodes.vue"),
        },
        {
          path: "user/club",
          name: "club1",
          meta: { title: "¿Qué es el club?" },
          component: () => import("@/views/login/club.vue"),
        },
        {
          path: "user/contactanos",
          name: "contact1",
          meta: { title: "Contáctanos" },
          component: () => import("@/views/login/contact.vue"),
        },
        {
          path: "/ganadores",
          name: "coljuegosProfile",
          meta: { title: "Sorteo" },
          component: () => import("@/views/user/admin/coljuegosHome.vue"),
        },
        {
          path: "user/alliances/:name",
          name: "alliances1",
          meta: {
            title: "Alianzas"
          },
          component: () => import("@/views/login/alliances.vue"),
        },
        {
          path: "user/allianceDetail/:id",
          name: "allianceDetail",
          props: true,
          meta: {
            title: "Detalle Alianza"
          },
          component: () => import("@/views/login/alliancesDetail.vue"),
        },
      ],
    },
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});
